'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var tailwindMerge = require('tailwind-merge');

/**
 * 기본 입력 필드 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 props
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {boolean} [props.isError] - 에러 상태 표시 여부
 * @param {boolean} [props.isFocused] - 포커스 상태 표시 여부
 * @param {boolean} [props.disabled] - 비활성화 상태 여부
 *
 * @extends {InputHTMLAttributes<HTMLInputElement>} HTML input 요소의 기본 속성들을 모두 지원합니다.
 *
 * @example
 * // 기본 사용
 * <Input placeholder="텍스트를 입력하세요" />
 *
 * // 비활성화 상태
 * <Input disabled placeholder="입력할 수 없습니다" />
 *
 * // 커스텀 클래스 적용
 * <Input className="custom-input" placeholder="커스텀 스타일" />
 *
 * // 에러 상태
 * <Input isError placeholder="에러 상태" />
 */ const Input = react.forwardRef((_a, ref)=>{
    var { disabled, className, isError, isFocused } = _a, rest = _tslib.__rest(_a, [
        "disabled",
        "className",
        "isError",
        "isFocused"
    ]);
    return jsxRuntime.jsx("input", Object.assign({
        role: "text-input",
        ref: ref,
        className: tailwindMerge.twMerge('w-full tracking-default text-w-gray-600 outline-none typo-body1 placeholder:tracking-default placeholder:text-w-gray-300 placeholder:typo-body1 disabled:bg-w-gray-10', disabled && 'cursor-not-allowed text-w-gray-300 placeholder:text-w-gray-200 placeholder:typo-body1', className),
        "data-testid": "design-system--input",
        disabled: disabled
    }, rest));
});
Input.displayName = 'Input';

module.exports = Input;
